/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Router configuration for TariffsAndServices
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.4.0
 */

import { EBasketType } from '../../modules/app/appConstants';
import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { EProductsPageFrom } from '../../pages/PageProducts/tariffsAndServicesConstants';
import { IWizardRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export interface IProductsRouteConfiguration extends IWizardRouterConfiguration {
    pageFrom: EProductsPageFrom;
}

export const ProductsRouteConfiguration: IProductsRouteConfiguration[] = [
    {
        basketType: EBasketType.HEADER,
        breadCrumbs: [],
        pageFrom: EProductsPageFrom.HEADER,
        path: RoutePath.products,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [EBreadCrumbType.subscriberMobile, EBreadCrumbType.productsFromSubscribers],
        pageFrom: EProductsPageFrom.SUBSCRIBERS,
        path: RoutePath.productsFromSubscribers,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.subscriberMobileInfo,
            EBreadCrumbType.productsFromSubscriberId,
        ],
        pageFrom: EProductsPageFrom.SUBSCRIBER_ID,
        path: RoutePath.productsFromSubscriberId,
    },
];
